import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import OverrideRatesProposalPlans from 'components/proposal-override-rates';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import { redirectToRoute } from 'routes/redirectToRoute';
import { RouteV2Id } from 'routes/routesConfigV2';
import ProposalOverrideRatesPageStore, {
  ProposalOverrideRatesPageStoreContext,
  useProposalOverrideRatesPageStore,
} from 'store/modules/override-rates/proposal-override-rates/pageStore';

const PageContent: React.FC = observer(() => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();
  const { isLoading, getInitialData } = useProposalOverrideRatesPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <PageInFlowNoSidebarLayout
      contentWidth="standard"
      isInitialLoading={isLoading}
      domainParams={{ groupId, periodId, cartId }}
      pageId={RouteV2Id.QUOTE_OVERRIDE_RATES}
      pageHeader={{ subtitleMaxWidth: '50rem' }}
    >
      <OverrideRatesProposalPlans />
    </PageInFlowNoSidebarLayout>
  );
});

const QuoteOverrideRatesPage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();

  const pageStore = useMemo(
    () =>
      new ProposalOverrideRatesPageStore(
        { enrollmentPeriodId: periodId, groupId, cartId },
        {
          onReturnBack: (): void => {
            redirectToRoute(RouteV2Id.INITIATE_SHELF_ADD_QUOTE, { groupId, periodId, cartId });
          },
          onOverrideRates: ({ portfolioId, productLineId, bcIndex }): void => {
            redirectToRoute(RouteV2Id.QUOTE_OVERRIDE_RATES_PLAN, {
              groupId,
              periodId,
              cartId,
              portfolioId: decodeURIComponent(portfolioId),
              productLineId,
              bcIndex: String(bcIndex),
            });
          },
        },
      ),
    [],
  );

  return (
    <ProposalOverrideRatesPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </ProposalOverrideRatesPageStoreContext.Provider>
  );
};

export default QuoteOverrideRatesPage;
